<template>
  <div class="section-container">
    <div
      class="section-label"
      @click="$router.push('/' + section.name)"
      :class="currentPageClass('/' + section.name)"
    >
      <div class="section-icon-container">
        <i class="material-icons section-icon" :class="{'grey-out': isFree}">{{ section.icon }}</i>
      </div>
      {{ section.title }}
      <div class="clearfix"></div>
    </div>
    <div class="pages-container">
      <div
        v-for="page in section.pages"
        :key="page.id"
        class="page-label"
        :class="currentPageClass('/' + section.routing + '/' + page.route)"
      >
        <div
          @click="$router.push('/' + section.routing + '/' + page.route)"
          class="page-label-text"
        >
          <i
            v-if="page.changesRequested"
            class="material-icons page-icon bounce"
            :class="{ completed: page.isCompleted }"
          >
            announcement<!--message-->
          </i>
          <i
            v-else-if="page.dueSoon"
            class="material-icons page-icon bounce"
            :class="{ completed: page.isCompleted }"
          >
          hourglass_bottom<!-- hourglass_bottom timer watch_later-->
          </i>
          <i
            v-else-if="page.actionRequested"
            class="material-icons page-icon bounce"
            :class="{ completed: page.isCompleted }"
          >
          warning<!-- hourglass_bottom timer watch_later-->
          </i>
          <i
            v-else
            class="material-icons page-icon"
            :class="{ completed: page.isCompleted, notify: page.showActionInformation }"
          >
            turned_in
          </i>
          <template v-if="section.name === 'author'">{{ page.title }}</template>
          <template v-else-if="section.name === 'social'">{{
            page.title
          }}</template>
          <template v-else>
            <span :class="{ 'text-completed': page.isCompleted }">{{
              page.book.title
            }}</span>
          </template>
        </div>
      </div>
      <div
        class="page-label"
        :class="currentPageClass('/' + section.routing + '/add')"
        v-if="section.name === 'author' && user.memberType === 'paid'"
        @click="$router.push('/' + section.routing + '/add')"
      >
        <i class="material-icons add-icon">add_circle</i> Add Book
      </div>
      <div
        class="page-label page-label-find-book"
        v-if="section.name === 'reader' && user.memberType !== 'friend'"
        @click="$router.push('/browse')"
      >
        <i class="material-icons add-icon">add_circle</i>
        <span v-if="user.memberType === 'friend'">&nbsp;Pick Book</span>
        <span v-else>Library</span>
      </div>
      <!-- <div
        class="page-label"
        v-if="section.name === 'social'"
        @click="$router.push('/social/earn')"
        :class="currentPageClass('/social/earn')"
      >
        <i class="material-icons social-earn-icon">favorite_border</i> Like &
        Earn
      </div> -->
      <!-- <div
        class="page-label"
        v-if="section.name === 'social'"
        @click="$router.push('/social/promote')"
        :class="currentPageClass('/social/promote')"
      >
        <i class="material-icons social-icon">timeline</i> Get Promoted
      </div> -->

      <div
        class="page-label"
        v-if="section.name === 'social_athlete'"
        @click="$router.push('/read/leaderboard')"
        :class="currentPageClass('/read/leaderboard')"
      >
        <i class="material-icons social-earn-icon">timeline</i>
        Leaderboard
      </div>

      <div
        class="page-label"
        v-if="section.name === 'help'"
        @click="$router.push('/snaps')"
        :class="currentPageClass('/snaps')"
      >
        <i class="material-icons help-icon">bookmark_border</i> Earn Snaps
      </div>
      <div
        class="page-label"
        v-if="section.name === 'help'"
        @click="clickHelp"
        :class="currentPageClass('/contact')"
      >
        <i class="material-icons help-icon">bookmark_border</i> Contact Us
      </div>
      <!-- <div class="page-label" v-if="section.name === 'help'" @click="$router.push('/snaps')">
        <i class="material-icons help-icon">bookmark_border</i> Watch Videos
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSection",
  props: ["section", "currentRoute", "user"],
  data: function () {
    return {};
  },
  computed: {
    isFree(){
      return this.section.name == 'author' && this.user.memberType === 'free' ;
    }
  },
  methods: {
    currentPageClass(route) {
      return {
        "current-page": route === this.currentRoute,
      };
    },
    clickHelp() {
      window.Intercom("show");
    },
  },
  created() {
    // console.log("current route", this.$router.currentRoute, this.$router);
  },
};
</script>

<style scoped lang="scss">
.section-container {
  margin-top: 5px;
  margin-bottom: 0px;
  border-bottom: 0px solid #e7e7eb;
  padding-bottom: 20px;
  width: 100%;
  background: darken($color-sidebar, 3%);
}
.section-container:hover {
}

.section-icon {
  display: inline-block;
  margin-top: -5px;
  margin-left: 2px;
  font-size: 15pt;
  color: $color-blue;
}

.section-icon.grey-out {
  color: grey !important;
}

.section-icon-container {
  float: left;
  margin-top: 4px;
  width: 26px;
  height: 12px;
}

.section-label {
  padding: 3px 0 0px 20px;
  font-weight: 600;
  font-size: 16pt !important;
  font-family: "Source Sans Pro";
  color: #222;
}
.section-label:hover {
  background: darken($color-sidebar, 8%);
  cursor: pointer;
}

.page-icon {
  padding-right: 3px;
  font-size: 12pt;
  color: #ffa726;
}

.page-icon.bounce {
  scale: 105%;
  color: $color-red;
  animation: bounce 2s ease infinite;
}
.completed {
  color: lighten($color-blue, 15%);
}
.pages-container {
  text-align: left;
}
.page-label {
  padding: 4px 8px 0.05em 26px;
  font-weight: 400;
  font-size: 14pt !important;
  font-family: "Source Sans Pro";
  color: #222;
}
.page-label:hover {
  background: darken($color-sidebar, 8%);
  cursor: pointer;
}
.page-label-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current-page {
  background: darken($color-sidebar, 8%) !important;
}

.text-completed {
  //opacity: 0.7;
}

.add-icon {
  font-size: 12pt;
  color: #66bb6a;
}
.social-icon {
  font-size: 12.5pt;
  color: lighten(#ab47bc, 5%);
}
.social-earn-icon {
  font-size: 12.5pt;
  color: lighten(#ef5350, 5%);
}

.help-icon {
  font-size: 12.5pt;
  color: $color-blue;
}

.notify {
  color: $color-red;
  opacity: 80%;
}
</style>